import { Inject, Injectable, DOCUMENT } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class CanonicalService {
  constructor(@Inject(DOCUMENT) private doc: Document) {}

  updateCanonicalUrl(): void {
    const links = this.doc.getElementsByTagName('link');
    const existingLink = links.length > 0 && Array.from(links).find((x) => x.rel === 'canonical');

    // Get the path after the first / from the current URL
    const url = new URL(this.doc.URL);
    const path = url.pathname.replace(/^\//, ''); // Remove leading slash

    // Combine baseUrl from environment with the current path
    const canonicalUrl = environment.baseUrl + path;

    if (existingLink) {
      existingLink.setAttribute('href', canonicalUrl);
    } else {
      const link: HTMLLinkElement = this.doc.createElement('link');
      link.setAttribute('rel', 'canonical');
      this.doc.head.appendChild(link);
      link.setAttribute('href', canonicalUrl);
    }
  }
}
